import { gql } from '@apollo/client';
import { RoleNames } from '@/generated/codegen';

export const ROLE_LABELS: Record<RoleNames, string> = {
  machinist: 'Operario',
  mechanic: 'Mecánico',
  admin: 'Administrador',
  manager: 'Manager',
  root: 'Root',
  superRoot: 'Super Root',
  fuel_dispatcher: 'Despachante de Combustible',
  btrack: 'B-Track',
  rental_approver: 'Aprobador de Rental',
  rental_external_approver: 'Aprobador Externo de Rental',
  rental_issuer: 'Emisor de Rental',
};

export const MY_USER_FIELDS = gql`
  fragment MyUserData on Me {
    id
    first_name
    last_name
    dni
    username
    birthday
    email
    phone
    address
    cuil
    gender
    can_create_company
    is_managed
    identity_claim {
      requested_email
      kind
    }
    incoming_merge {
      company_name
      managed_username
    }
    pending_email
    roles {
      id
      role
      label @client
      company {
        id
        name
        slug
        logo_url
        modules_enabled {
          module_id
          end_date
        }
      }
      business_unit {
        id
        name
        slug
      }
      project {
        id
        name
        slug
        business_unit {
          id
        }
      }
    }
    invitations {
      id
      ...InvitationFields
    }
    identifier_hash
  }
`;

export const UPDATE_ME_INPUT = [
  'first_name',
  'last_name',
  'birthday',
  'phone',
  'address',
  'cuil',
  'gender',
];

export const UPDATE_ME_FEDERATED_INPUT = [
  'dni',
  'first_name',
  'last_name',
  'birthday',
  'phone',
  'address',
  'cuil',
  'gender',
];

export const UPDATE_ME = gql`
  mutation UpdateMyUser($input: UpdateMeInput!) {
    updateMe(input: $input) {
      ... on UpdateMe {
        item {
          ...MyUserData
        }
      }
      ... on Error {
        message
      }
    }
  }
`;

export const UPDATE_ME_FEDERATED = gql`
  mutation UpdateMyUserFederated(
    $input: UpdateFederatedIdentityInformationInput!
  ) {
    updateFederatedIdentityInformation(input: $input) {
      ... on MeItem {
        item {
          ...MyUserData
        }
      }
      ... on Error {
        message
      }
    }
  }
`;

export const GET_MY_USER = gql`
  query GetMe {
    getMe {
      ... on GetMe {
        item {
          ...MyUserData
        }
      }
      ... on Error {
        message
      }
      ... on ProfileDataMissingError {
        message
        data_missing
        partial_profile {
          id
          first_name
          last_name
          dni
          email
          phone
          address
          cuil
          gender
          incoming_merge {
            company_name
            managed_username
          }
        }
      }
    }
  }
`;

export const REJECT_INVITATION = gql`
  mutation RejectInvitation($id: ID!) {
    rejectInvitation(id: $id) {
      ... on RejectInvitation {
        item {
          ...MyUserData
        }
      }
      ... on Error {
        message
      }
    }
  }
`;

export const ACCEPT_INVITATION = gql`
  mutation AcceptInvitation($id: ID!) {
    acceptInvitation(id: $id) {
      ... on AcceptInvitation {
        item {
          ...MyUserData
        }
      }
      ... on Error {
        message
      }
    }
  }
`;
